import {
  RouteRef,
  SubRouteRef,
  createRouteRef,
  createSubRouteRef,
} from '@backstage/core-plugin-api';

export enum RoutesIds {
  explore = 'explore',
  conversation = 'conversation',
}

// root route
export const exploreRouteRef = createRouteRef({
  id: RoutesIds.explore,
});

export const rootRouteRef = exploreRouteRef;

// sub-routes within the plugin
export const conversationRouteRef = createSubRouteRef({
  id: RoutesIds.conversation,
  parent: rootRouteRef,
  path: '/:conversationId',
});

// default routes/routes to be used by other plugins
export const Routes = {
  explore: exploreRouteRef,
  conversation: conversationRouteRef,
} satisfies Record<RoutesIds, SubRouteRef | RouteRef>;
